export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.nhif-monthly-report.index`,
        path: `/${prefix}/${pre}/nhif-monthly-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.nhif-monthly-report.index`,
                PageDescription: "Accounts/Finance Reports: Nhif Invoices Monthly  report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.prints.nhif-monthly-report.index`,
        path: `/${prefix}/${pre}/nhif-monthly-report/print`,
        component: () => import('./prints/NhifInvoiceReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.nhif-monthly-report.index`,
                PageDescription: "Accounts/Finance Reports: Nhif Invoices Monthly  report",
            },
            print: true,
        },
    },
];